import { mapActions } from 'vuex';

export default {
  data() {
    return {
      workers: [],
    };
  },
  methods: {
    ...mapActions(['activeAlert']),
    terminateAllWorkers() {
      if (this.workers && this.workers.length > 0) {
        this.workers.forEach(w => w.terminate());
        this.workers = [];
      }
    },
    startGenerationLoader(customMessage) {
      this.$store.dispatch('startCancellable', {
        message: customMessage || this.$t('shared.loader.generating'),
        onCancel: () => {
          this.terminateAllWorkers();
          this.$store.dispatch('hideLoader');

          this.activeAlert({
            message: this.$t('shared.loader.cancelled'),
            theme: 'warning',
          });
        },
      });
    },
    cancelPreviousGeneration() {
      this.$store.dispatch('cancelRequest');
      this.terminateAllWorkers();
    },
    cleanupWorkers() {
      this.terminateAllWorkers();
      this.$store.dispatch('hideLoader');
    },
  },
  destroyed() {
    this.cancelPreviousGeneration();
  },
};
